import React, { Component } from "react";
import Joi from "joi-browser";
import Input from "../input/input";
import InputGroup from "../inputGroup/inputGroup";
import IconInput from "../iconInput/iconInput";
import Select from "../select/select";
import SelectWithOptionGroup from "../select/selectWithOptionGroup";
import Checkbox from "../checkbox/checkboxSwitch";
import DateInput from "../dateInput/dateInput";
import AutoSelect from "../autoSelect/autoSelect";

class Form extends Component {
  state = {
    data: {},
    errors: {},
    selectedOption: null,
    isLoading: false,
  };

  validate = () => {
    const options = { abortEarly: false, stripUnknown: true };
    const { error } = Joi.validate(this.state.data, this.schema, options);
    if (!error) return null;
    const errors = {};
    for (let item of error.details) {
      // console.log("item", item);

      errors[item.path[0]] = item.message;
    }
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleSubmit = (e) => {
    this.setState({ isLoading: true });
    e.preventDefault();
    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) {
      this.setState({ isLoading: false });
      return;
    }
    this.doSubmit();
    this.setState({ isLoading: false });
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    var errorMessage = this.validateProperty(input);
    if (input.name == "price" && errorMessage != null) {
      errorMessage = errorMessage.replace("price", "point");
    }
    if (input.name == "points" && errorMessage != null) {
      errorMessage = errorMessage.replace("points", "price");
    }
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];
    const data = { ...this.state.data };
    data[input.name] = input.value;
    if (input.name.includes("assword")) {
      if (data.confirmPassword != undefined) {
        if (data.confirmPassword === data.password) {
          delete errors[input.name];
        }
      }
    }
    this.setState({ data, errors });
  };

  handleCheckboxChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const validInput = { name: input.name, value: input.checked };
    const errorMessage = this.validateProperty(validInput);
    if (errorMessage) errors[input.name] = errorMessage;
    const data = { ...this.state.data };
    if (input.checked) {
      delete errors[input.name];
      data[input.name] = input.checked = 1;
      this.setState({ data, errors });
    } else {
      data[input.name] = input.checked = 0;
      delete errors[input.name];
      this.setState({ data, errors });
    }
  };

  handleDateChange = (date, name) => {
    const errors = { ...this.state.errors };
    const validInput = { name: name, value: date };
    const errorMessage = this.validateProperty(validInput);
    if (errorMessage) errors[name] = errorMessage;
    if (name === "startDate" || name === "endDate") {
      if (name === "startDate") {
        //this.state.data.startDate = date;
        const { data } = this.state;
        data.startDate = date;
        this.setState({ data });
      }
      if (name === "endDate" && this.state.data.startDate < date) {
        //this.state.data.endDate = date;
        const { data } = this.state;
        data.endDate = date;
        this.setState({ data });
        delete errors[name];
      }
    } else {
      if (name === "stockInDate") {
        const { data } = this.state;
        data[name] = date;
        this.setState({ data });
      }
    }

    this.setState({ errors });
  };

  handleAutoSelectChange = (e, name) => {
    const data = { ...this.state.data };
    this.setState({ selectedOption: e });
    if (e == null) {
      data[name] = null;
      this.setState({ data });
      return;
    }
    const errors = { ...this.state.errors };
    const input = { name: name, value: e.value };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[name] = errorMessage;
    else delete errors[name];
    data[name] = e.value;
    this.setState({ data, errors });
  };

  renderButton(label, name = "Submit", loading = false, disabled = false) {
    const { isLoading } = this.state;
    if (label === "Search") {
      label = <i className="fa fa-search" />;
      return (
        <button
          disabled={disabled || this.validate() || isLoading || loading}
          className="btn btn-primary"
        >
          {label}
        </button>
      );
    } else {
      return (
        <button
          disabled={disabled || this.validate() || isLoading || loading}
          className="btn btn-primary"
        >
          {isLoading || loading ? (
            <i className="fa fa-refresh fa-spin ml-2" />
          ) : (
            <i className="fa fa-check" />
          )}{" "}
          {label}
        </button>
      );
    }
  }

  renderAutoSelect(
    name,
    options,
    disabled = false,
    selectedValue = null,
    isClearable = false
  ) {
    var { selectedOption, errors } = this.state;
    selectedOption = options.find((o) => o.value == selectedValue);

    return (
      <AutoSelect
        name={name}
        value={selectedOption}
        options={options}
        onChange={(e) => this.handleAutoSelectChange(e, name)}
        error={errors[name]}
        disabled={disabled}
        isClearable={isClearable}
      />
    );
  }

  renderCehckbox(name, label, type = "checkbox") {
    const { data, errors } = this.state;
    return (
      <Checkbox
        type={type}
        name={name}
        checked={data[name]}
        label={label}
        onChange={this.handleCheckboxChange}
        error={errors[name]}
      />
    );
  }

  renderDateInput(name, label, dateFormat, disabled = false) {
    const { data, errors } = this.state;
    return (
      <DateInput
        name={name}
        value={data[name]}
        label={label}
        dateFormat={dateFormat}
        onChange={(e) => this.handleDateChange(e, name)}
        error={errors[name]}
        disabled={disabled}
      />
    );
  }

  renderSelect(
    name,
    label,
    options,
    isDefault = true,
    defaultText,
    disabled = false
  ) {
    const { data, errors } = this.state;
    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
        isDefault={isDefault}
        defaultText={defaultText}
        disabled={disabled}
      />
    );
  }

  renderSelectWithOptionGroup(name, label, options) {
    const { data, errors } = this.state;
    return (
      <SelectWithOptionGroup
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderInput(name, label, type = "text", disabled = true) {
    const { data, errors } = this.state;
    return (
      <Input
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        disabled={disabled}
      />
    );
  }

  renderInputGroup(name, label, addOn = "Point", isPrepend, disabled = true) {
    const { data, errors } = this.state;
    return (
      <InputGroup
        type="text"
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
        addOn={addOn}
        isPrepend={isPrepend}
        disabled={disabled}
      />
    );
  }

  renderInputPassword(name, label, type, disabled = true) {
    const { data, errors } = this.state;
    return (
      <div>
        <Input
          type={type}
          name={name}
          value={data[name]}
          label={label}
          onChange={this.handleChange}
          error={errors[name]}
          disabled={disabled}
        />
      </div>
    );
  }

  renderIconInput(name, label, iconName, type = "text") {
    const { data, errors } = this.state;
    return (
      <IconInput
        type={type}
        name={name}
        value={data[name]}
        label={label}
        iconName={iconName}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }
}

export default Form;
